import { useQuery } from '@tanstack/react-query'
import { getUserVoice } from '../../service/list'

function useGetUserVoice() {
  return useQuery({
    queryKey: ['user-voice'],
    queryFn: () => getUserVoice(),
  })
}

export default useGetUserVoice
